/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeleteFacilityPhysician200ResponseData } from './DeleteFacilityPhysician200ResponseData';
import {
    DeleteFacilityPhysician200ResponseDataFromJSON,
    DeleteFacilityPhysician200ResponseDataFromJSONTyped,
    DeleteFacilityPhysician200ResponseDataToJSON,
    DeleteFacilityPhysician200ResponseDataToJSONTyped,
} from './DeleteFacilityPhysician200ResponseData';

/**
 * 
 * @export
 * @interface DeleteFacilityPhysician200Response
 */
export interface DeleteFacilityPhysician200Response {
    /**
     * 
     */
    data?: DeleteFacilityPhysician200ResponseData;
}

/**
 * Check if a given object implements the DeleteFacilityPhysician200Response interface.
 */
export function instanceOfDeleteFacilityPhysician200Response(value: object): value is DeleteFacilityPhysician200Response {
    return true;
}

export function DeleteFacilityPhysician200ResponseFromJSON(json: any): DeleteFacilityPhysician200Response {
    return DeleteFacilityPhysician200ResponseFromJSONTyped(json, false);
}

export function DeleteFacilityPhysician200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityPhysician200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : DeleteFacilityPhysician200ResponseDataFromJSON(json['data']),
    };
}

export function DeleteFacilityPhysician200ResponseToJSON(json: any): DeleteFacilityPhysician200Response {
    return DeleteFacilityPhysician200ResponseToJSONTyped(json, false);
}

export function DeleteFacilityPhysician200ResponseToJSONTyped(value?: DeleteFacilityPhysician200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DeleteFacilityPhysician200ResponseDataToJSON(value['data']),
    };
}

